import {ChangeDetectorRef, Component, forwardRef, HostBinding, OnInit} from "@angular/core";
import {NewStockViewComponent} from "../new-stock-view/new-stock-view.component";
import {FormBuilder} from "@angular/forms";
import {StockItemService} from "../../services/stock-item-service/stock-item.service";

@Component({
  selector: 'vb-stock-form-table',
  templateUrl: './stock-form-table.component.html',
  styleUrls: ['./stock-form-table.component.css'],
  providers: [{provide: NewStockViewComponent, useExisting: forwardRef(() => StockFormTableComponent)}]
})
export class StockFormTableComponent extends NewStockViewComponent implements OnInit {

  @HostBinding('class.tr')
  trClass = true;

  constructor(fb: FormBuilder, cd: ChangeDetectorRef, stockItemService: StockItemService) {
    super(fb, cd, stockItemService);
  }

  ngOnInit() {
    super.ngOnInit();
  }

}



// WEBPACK FOOTER //
// ./src/app/store-management/stock/stock-form-table/stock-form-table.component.ts